export enum AssignmentParticipantAttendanceStateEnum {
    Undefined = 1,
    Attended = 2,
    Absent = 3,
}